<h4 mat-dialog-title *ngIf="modalData" style="margin: 0; padding-left: 50px;">{{ modalData.title }}</h4>

<!-- {{modalData|json}} -->

<mat-dialog-content *ngIf="modalData" class="previewContent">
  <h2 class="mt-3">{{ modalData.articalForm.articalTital }}</h2>

  <div class="row justify-content-between">
    <div class="col-4">
      <p>จำนวนการอ่าน 0 ครั้ง</p>
    </div>
    <div class="col-4">
      <p *ngIf="modalData.articalForm.articalAlwaysOpen == 'true'"
        [class.d-none]="modalData.articalForm.articalAlwaysOpen == 'false'" class="text-right">
        วันที่ {{ dateAlwaysOpen | date }}
      </p>
      <p *ngIf="modalData.articalForm.articalAlwaysOpen == 'false'"
        [class.d-none]="modalData.articalForm.articalAlwaysOpen == 'true'" class="text-right">
        วันที่ {{ modalData.articalForm.articalDate[0] | date }}
      </p>
    </div>
  </div>

  <img [src]="modalData.articalHeader" style="width: 100%;">

  <div class="row">
    <div class="col-12">
      <div class="mt-4" id="_content" [innerHtml]="modalDataDetails"></div>
    </div>
  </div>
  <div *ngIf="modalData.havePoll && isPollTime" class="row mt-4">
    <div class="col-12 text-center">
      <h5><b>{{ modalData.pollForm.pollQuestion }}</b></h5>
      <mat-radio-group>
        <mat-radio-button class="mr-3" value="1">{{ modalData.pollForm.pollChoice1 }}
        </mat-radio-button>
        <mat-radio-button value="2">{{ modalData.pollForm.pollChoice2 }}</mat-radio-button>
      </mat-radio-group>
      <br>
      <lifedi-btn lable="ส่ง" customStyle="color: white; background-color: #3E8C1A; width: 100px;">
      </lifedi-btn>
    </div>
  </div>

  <div class="p-4 mt-4 mb-4" style="background-color: white;">
    <div class="row justify-content-center">
      <img class="profilePic p-2" [src]="modalData.profile.PROFILE_PIC">
    </div>
    <div class="row justify-content-center mt-3">
      <h4>{{ modalData.profile.USERNAME }}</h4>
    </div>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="center">
  <button *ngIf="!modalData.isEdit&&!modalData.articalId" mat-button class="lifedi-btn-success"
    (click)="createArtical()">
    {{ modalData.actionBtnText }}
  </button>
  <button *ngIf="modalData.isEdit" mat-button class="lifedi-btn-success" (click)="editArtical()">
    บันทึก
  </button>
  <button mat-button [mat-dialog-close]="true">
    {{ modalData.cancleBtnText }}
  </button>
</mat-dialog-actions>

<div *ngIf="isLoading">
  <div
    style="position: fixed; z-index: 900; width: 100vw; height: 100vh; opacity: 80; top: 0; left: 0; background: #e8e8e880;">
  </div>
  <mat-spinner class="spinner-center" style="z-index: 1000;"></mat-spinner>
</div>
